import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormError } from "../../components/FormError";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { MessageModel } from "../../components/MessageModel";
import SelectBox from "./SelectBox";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import defaultConfig from "../../config/Config";
import { reset } from "../../slices/PermissionsSlice";
export function RoleForm(moduleList) {
  const navigate = useNavigate()
  const status = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
  ];
  console.log(moduleList)
  const dispatch = useDispatch();
  const successMessage = useSelector((state) => state.permissions.success);
  const errorMessage = useSelector((state) => state.permissions.error);
  const [ permissions, setPermissions ] = useState([])
  //const loading = useSelector((state) => state.permissions.loading);

  const formSchema = Yup.object().shape({
    label: Yup.string().required("Please enter role name"),
    status: Yup.string().required("Please select status"),
    // permissions: Yup.array()
    //   .of(
    //     Yup.object().shape({
    //       permissionId:Yup.string,
    //       access:Yup.string 
    //     })
    //   ).compact( (v) => !v.access ).min(1, "Please select atleast one permission")

      
  });
  const {
    control,
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    name: "role",
    mode: "onBlur",
    resolver: yupResolver(formSchema),
  });

  //const watchFieldArray = watch("permission");
  const {permission, roleData, parentRoleList} = moduleList.data;
  const onSubmit = function (data) {
    data.parentRoleId = data.parentRoleId || "";
    dispatch(moduleList.savePermission(data));
  };

  const btnCancel = function () {
    navigate('/roles')
  };

  const handelChange = function(event){
      //replace(event.target.name, event.target.checked )
  }

  useEffect( () => {
    setPermissions(permission)
  }, [permission, setPermissions])

  useEffect( () => {
    if(roleData){
      for( let key in roleData ){
        if(key !== "permissions"){
          setValue(key, roleData[key])
        }else if(permissions.length > 0 ){
          roleData.permissions.forEach( (item, index) => {
            setValue(`permissions.${index}.webAccessRead`, item?.webAccessRead)
            setValue(`permissions.${index}.webAccessWrite`, item?.webAccessWrite)
            setValue(`permissions.${index}.webAccessEdit`, item?.webAccessEdit)
            setValue(`permissions.${index}.appAccess`, item?.appAccess)
          } )
        }
      }
    }
  },[roleData, permissions, setValue])

  const redirectToLogin = () => {
    dispatch(reset())
    if(successMessage){
      navigate("/roles")
    } 
  }
  return (
    <React.Fragment>
      <div className="col-md-6 col-lg-12">
        <div className="card payment-card">
          <div className="card-header">
            <h4 className="card-title">NEW ROLE INFORMATION</h4>
          </div>
          <div className="card-body pt-0">
            <form onSubmit={handleSubmit(onSubmit)}>
            
              <div className="row">
                <div className="col-3">
                  <div className="form-group mb-3">
                    <label
                      htmlFor="name"
                      className={`input-label ${errors.label && "error"}`}
                    >
                      Name
                    </label>
                    <input
                      {...register("label")}
                      type="text"
                      className={`input-txt form-control ${
                        errors.name && "error"
                      }`}
                      placeholder=" Name"
                    />
                    {errors.label && <FormError message={errors.label.message} />}
                  </div>
                </div>
                <div className="col-3">
                  <div className="form-group mb-3">
                    <label
                      htmlFor="name"
                      className={`input-label ${errors.parentRole && "error"}`}>
                      Parent Role
                    </label>
                    <Controller
                      control={control}
                      name="parentRoleId"
                      render={({ field: { value, onChange } }) => (
                        <SelectBox
                          options={parentRoleList}
                          isClearable={true}
                          onChange={(opt) => onChange(opt?.value)}
                          value={parentRoleList.find(
                            (option) => option.value === value
                          )}
                        />
                      )}
                    />
                  </div>
                </div> 
                <div className="col-3">
                  <div className="form-group mb-3">
                    <label
                      htmlFor="card-number"
                      className={`d-block ${errors.status && "error"}`}
                    >
                      Status
                    </label>
                    <Controller
                      control={control}
                      name="status"
                      value={status[0]["value"]}
                      defaultValue={status[0]["value"]}
                      render={({ field: { value, onChange } }) => (
                        <SelectBox
                          options={status}
                          isClearable={true}
                          onChange={(opt) => onChange(opt?.value)}
                          value={status.find(
                            (option) => option.value === value
                          )}
                        />
                      )}
                    />
                    {errors.status && (
                      <FormError message={errors.status.message} />
                    )}
                  </div>
                </div>
                <div className="col-3">
                  <div className="form-group mb-3">
                    <label
                      htmlFor="card-number"
                      className={`d-block ${errors.isMaster && "error"}`}
                    >
                      Is Master
                    </label>
                    <Controller
                      control={control}
                      name="isMaster"
                      value={defaultConfig.generalStatus[0]["value"]}
                      defaultValue={defaultConfig.generalStatus[0]["value"]}
                      render={({ field: { value, onChange } }) => (
                        <SelectBox
                          options={defaultConfig.generalStatus}
                          isClearable={true}
                          onChange={(opt) => onChange(opt?.value)}
                          value={defaultConfig.generalStatus.find(
                            (option) => option.value === value
                          )}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
              <React.Fragment>
              {errors.permissions && (
                  <FormError message={errors.permissions.message} />
                )}
                <table className="table table-bordered">
                  <thead className="thead-dark">
                    <tr>
                      <th rowSpan={2} width="50%" className="text-center align-middle" scope="col">Modules</th>
                      <th colSpan={3} width="25%" className=" text-center uppercase font-bold text-xl ">
                        Web Access 
                      </th>
                      <th width="25%" className=" text-center uppercase font-bold text-xl ">
                        App Access 
                      </th>
                    </tr>
                    <tr>
                      <th className="text-center">
                        Read
                      </th>
                      <th className="text-center">
                        Write
                      </th>
                      <th className="text-center">
                        Edit
                      </th>
                      <th className="text-center"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {permissions?.map((item, index) => {

                      return (
                        <tr className="bg-gray-100" key={index}>
                          <td className="text-left py-4 px-4 uppercase font-bold text-2xl ">
                            {item.moduleName}
                            <input
                              type="hidden"
                              value={item.id}
                              {...register(
                                `permissions.${index}.permissionId`
                              )}
                            />
                          </td>
                          <td className="text-center align-middle">
                            {
                              item.showWebAccess? 
                              <input
                                type="checkbox"
                                //name={`permission[${index}]read`}
                                className="w-8 h-8"
                                {...register(`permissions.${index}.webAccessRead`)}
                                onChange={(event) => handelChange(event)}
                              />:''
                            }
                            
                          </td>
                          <td className="text-center align-middle">
                            {
                              item.showWebAccess? 
                              <input
                                type="checkbox"
                                //name={`permission[${index}]read`}
                                className="w-8 h-8"
                                {...register(`permissions.${index}.webAccessWrite`)}
                                onChange={(event) => handelChange(event)}
                              />:''
                            }
                            
                          </td>
                          <td className="text-center align-middle">
                            {
                              item.showWebAccess? 
                              <input
                                type="checkbox"
                                //name={`permission[${index}]read`}
                                className="w-8 h-8"
                                {...register(`permissions.${index}.webAccessEdit`)}
                                onChange={(event) => handelChange(event)}
                              />:''
                            }
                            
                          </td>
                          <td className="text-center align-middle">
                            {
                              item.showAppAccess? <input
                              type="checkbox"
                              //name={`permission[${index}]read`}
                              className="w-8 h-8"
                              {...register(`permissions.${index}.appAccess`)}
                              onChange={(event) => handelChange(event)}
                            />:''
                            }
                            
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </React.Fragment>
              <div className="col-12 mb-3 mx-auto  mx-2 text-right">
                <button
                  type="submit"
                  className="btn btn-outline-success btn-lg mx-2"
                >
                  Submit
                </button>
                <button
                  type="button"
                  onClick={ (e) => btnCancel() }
                  className="btn btn-outline-danger btn-lg mx-2"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {successMessage || errorMessage ? (
        <MessageModel
          btnEvent={redirectToLogin}
          error={errorMessage}
          success={successMessage}
          message = {successMessage || errorMessage}
        />
      ) : (
        ""
      )}
    </React.Fragment>
  );
}
